/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  LearningGetResponse,
  LearningUpdateResponse,
  PatchedLearningRequest
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Retrieve learning content (intro, academy, faq). Visible to all authenticated users.
 * @summary Get learning content
 */
export const learningsRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<LearningGetResponse>(
      {url: `/api/learnings/`, method: 'GET', signal
    },
      );
    }
  

export const getLearningsRetrieveQueryKey = () => {
    return [`/api/learnings/`] as const;
    }

    
export const getLearningsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof learningsRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLearningsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof learningsRetrieve>>> = ({ signal }) => learningsRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LearningsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof learningsRetrieve>>>
export type LearningsRetrieveQueryError = unknown


export function useLearningsRetrieve<TData = Awaited<ReturnType<typeof learningsRetrieve>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof learningsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningsRetrieve<TData = Awaited<ReturnType<typeof learningsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof learningsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof learningsRetrieve>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLearningsRetrieve<TData = Awaited<ReturnType<typeof learningsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get learning content
 */

export function useLearningsRetrieve<TData = Awaited<ReturnType<typeof learningsRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof learningsRetrieve>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLearningsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update learning content (intro, academy, faq). Admin only.
 * @summary Update learning content
 */
export const learningsPartialUpdate = (
    patchedLearningRequest: PatchedLearningRequest,
 ) => {
      
      
      return customInstance<LearningUpdateResponse>(
      {url: `/api/learnings/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLearningRequest
    },
      );
    }
  


export const getLearningsPartialUpdateMutationOptions = <TError = LearningUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningsPartialUpdate>>, TError,{data: PatchedLearningRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof learningsPartialUpdate>>, TError,{data: PatchedLearningRequest}, TContext> => {

const mutationKey = ['learningsPartialUpdate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof learningsPartialUpdate>>, {data: PatchedLearningRequest}> = (props) => {
          const {data} = props ?? {};

          return  learningsPartialUpdate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type LearningsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof learningsPartialUpdate>>>
    export type LearningsPartialUpdateMutationBody = PatchedLearningRequest
    export type LearningsPartialUpdateMutationError = LearningUpdateResponse

    /**
 * @summary Update learning content
 */
export const useLearningsPartialUpdate = <TError = LearningUpdateResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof learningsPartialUpdate>>, TError,{data: PatchedLearningRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof learningsPartialUpdate>>,
        TError,
        {data: PatchedLearningRequest},
        TContext
      > => {

      const mutationOptions = getLearningsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    